
export class TipoReuniao {
    id: number;
    descricao: string;
}
